module.exports = __webpack_public_path__ + "static/0043-72c6f8a1bf7e711bb072b5256550608b.png";